// Generated by _dev/theme-assets.mjs from assets/js/site.js + _dev/theme-cart.js
// site.js — header, menu, dialogs, hero video, demo forms.
(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  // --- dialogs (shared with shop.js) --------------------------------------------
  const syncScrollLock = () => document.body.classList.toggle('has-dialog', $$('dialog[open]').length > 0);
  window.EDEN = {
    openDialog(d) {
      if (!d) return;
      if (!d.open) d.showModal();
      syncScrollLock();
    },
  };
  for (const d of $$('dialog')) {
    d.addEventListener('close', syncScrollLock);
    d.addEventListener('click', (ev) => {
      if (ev.target === d || ev.target.closest('[data-close]')) d.close();
    });
  }

  // --- header: see-through while it sits over a dark film or photo section -------------
  const header = $('[data-header]');
  if (header?.classList.contains('is-overlay')) {
    let queued = false;
    const update = () => {
      queued = false;
      const probe = header.offsetHeight - 1;
      const under = document.elementsFromPoint(window.innerWidth / 2, probe).find((el) => !header.contains(el));
      header.classList.toggle('is-solid', !under?.closest('[data-dark]'));
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
  }

  // --- mobile menu ----------------------------------------------------------------------
  const toggle = $('[data-menu-toggle]');
  const menu = $('[data-menu]');
  const setMenu = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Close' : 'Menu';
    menu.hidden = !open;
    header.classList.toggle('menu-open', open);
  };
  toggle?.addEventListener('click', () => setMenu(menu.hidden));
  menu?.addEventListener('click', (ev) => { if (ev.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape' && menu && !menu.hidden) setMenu(false); });
  window.matchMedia('(min-width: 1241px)').addEventListener('change', (m) => { if (m.matches && menu) setMenu(false); });

  // --- films: play only what is on screen; one control pauses all motion ----------------
  const videos = $$('video[data-auto]');
  const toggles = $$('[data-motion-toggle]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduce.matches;
  const onScreen = new Set();
  const sync = () => {
    for (const v of videos) {
      const visible = onScreen.has(v) && v.getClientRects().length > 0;
      if (visible && !paused) v.play().catch(() => {});
      else if (!v.paused) v.pause();
    }
    document.body.classList.toggle('motion-paused', paused);
    for (const t of toggles) {
      t.textContent = paused ? 'Play' : 'Pause';
      t.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} background video`);
    }
  };
  if (videos.length) {
    const io = new IntersectionObserver((entries) => {
      for (const en of entries) en.isIntersecting ? onScreen.add(en.target) : onScreen.delete(en.target);
      sync();
    }, { threshold: 0.15 });
    videos.forEach((v) => io.observe(v));
    window.addEventListener('resize', sync);
  }
  for (const t of toggles) t.addEventListener('click', () => { paused = !paused; sync(); });
  sync();

  // --- demo forms (no endpoint yet) --------------------------------------------------------------
  for (const form of $$('[data-demo-form]')) {
    form.addEventListener('submit', (ev) => {
      ev.preventDefault();
      if (!form.reportValidity()) return;
      const out = form.querySelector('.form-status') || form.nextElementSibling;
      if (out) out.textContent = form.dataset.success;
      form.reset();
    });
  }

  // visit.html?topic=studio preselects the studio inquiry
  const topic = new URLSearchParams(location.search).get('topic');
  const select = $('[data-topic]');
  if (topic && select) select.value = topic;
})();

// --- Shopify theme: bag drawer (AJAX Cart API), product page, shop filters --------------
// Everything also works without JavaScript: forms post to /cart and /cart/add as usual.
(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const root = window.Shopify?.routes?.root || '/';
  const currency = () => window.Shopify?.currency?.active || 'USD';
  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: currency() }).format(cents / 100);
  const sized = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');

  // --- bag -----------------------------------------------------------------------------
  const drawer = $('[data-bag]');
  let cart = null;

  async function request(path, init = {}) {
    const res = await fetch(`${root}${path}`, { ...init, headers: { Accept: 'application/json', ...(init.headers || {}) } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'The shop could not be reached.');
    return data;
  }
  const load = () => request('cart.js');
  const change = (key, quantity) => request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
  const add = async (form) => { await request('cart/add.js', { method: 'POST', body: new FormData(form) }); return load(); };

  const status = (msg) => { const el = drawer && $('[data-bag-status]', drawer); if (el) el.textContent = msg; };

  function render() {
    if (!cart) return;
    for (const el of $$('[data-bag-count]')) el.textContent = cart.item_count;
    if (!drawer) return;
    $('[data-bag-lines]', drawer).innerHTML = cart.items.length ? cart.items.map((l) => `
        <div class="bag-line">
          ${l.image ? `<a href="${esc(l.url)}"><img src="${esc(sized(l.image, 160))}" alt="" loading="lazy"></a>` : '<span></span>'}
          <div>
            <p class="bag-line-title"><a href="${esc(l.url)}">${esc(l.product_title)}</a></p>
            ${l.product_has_only_default_variant ? '' : `<p class="bag-line-variant">${esc(l.variant_title)}</p>`}
            <div class="bag-line-qty">
              <button type="button" data-line="${esc(l.key)}" data-set="${l.quantity - 1}" aria-label="Decrease ${esc(l.product_title)}">−</button>
              <span>${l.quantity}</span>
              <button type="button" data-line="${esc(l.key)}" data-set="${l.quantity + 1}" aria-label="Increase ${esc(l.product_title)}">+</button>
            </div>
          </div>
          <div class="bag-line-side">
            <span>${money(l.final_line_price)}</span>
            <button class="text-btn" type="button" data-line="${esc(l.key)}" data-set="0">Remove</button>
          </div>
        </div>`).join('') : '<p class="bag-empty">Your bag is empty.</p>';
    $('[data-bag-subtotal]', drawer).textContent = money(cart.items_subtotal_price);
    $('[data-checkout]', drawer).disabled = !cart.item_count;
  }

  async function run(task) {
    try { cart = await task(); status(''); }
    catch (err) { console.error(err); status(err.message || 'Something went wrong. Please try again in a moment.'); }
    render();
  }

  // --- shop filters (?c=Jewelry opens with that category) ------------------------------------
  const bar = $('[data-filters]');
  function applyFilter(name) {
    if (!bar) return;
    let tagline = bar.dataset.defaultTagline || '';
    for (const b of $$('[data-filter]', bar)) {
      const on = b.dataset.filter === name;
      b.setAttribute('aria-pressed', String(on));
      if (on && name !== 'All') tagline = b.dataset.tagline || '';
    }
    for (const li of $$('[data-filterable] .product')) li.hidden = name !== 'All' && li.dataset.category !== name;
    const line = $('[data-filter-tagline]');
    if (line) line.textContent = tagline;
    const url = new URL(location.href);
    if (name === 'All') url.searchParams.delete('c'); else url.searchParams.set('c', name);
    history.replaceState(null, '', url);
  }
  if (bar) {
    const wanted = new URLSearchParams(location.search).get('c');
    applyFilter(wanted && $$('[data-filter]', bar).some((b) => b.dataset.filter === wanted) ? wanted : 'All');
  }

  // --- product page ----------------------------------------------------------------------------
  const pdp = $('[data-product-page]');
  const mainImg = pdp && $('.pdp-main img', pdp);
  const variantSelect = pdp && $('[data-pd-variant]', pdp);
  function syncVariant() {
    if (!variantSelect) return;
    const opt = variantSelect.selectedOptions[0];
    const price = $('[data-pd-price]', pdp);
    if (opt?.dataset.price && price) price.textContent = opt.dataset.price;
    const btn = $('[data-pd-add]', pdp);
    const ok = opt && opt.dataset.available === 'true';
    btn.disabled = !ok;
    btn.textContent = ok ? 'Add to bag' : (btn.dataset.unavailable || 'Find in store');
  }
  variantSelect?.addEventListener('change', syncVariant);

  // Any Add to bag form (product page, Book Club): add without leaving the page, then show the bag.
  document.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    ev.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    await run(() => add(form));
    if (btn) { btn.disabled = false; btn.textContent = label; }
    syncVariant();
    window.EDEN.openDialog(drawer);
  });

  // --- clicks ------------------------------------------------------------------------------------
  document.addEventListener('click', (ev) => {
    const filter = ev.target.closest('[data-filter]');
    if (filter) {
      applyFilter(filter.dataset.filter);
      const section = filter.closest('.shop-section');
      if (section && section.getBoundingClientRect().top < 0) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const thumb = ev.target.closest('[data-thumb]');
    if (thumb && mainImg) {
      mainImg.src = thumb.dataset.src;
      mainImg.srcset = thumb.dataset.srcset || '';
      mainImg.alt = thumb.dataset.alt || '';
      for (const t of $$('[data-thumb]', pdp)) t.setAttribute('aria-pressed', String(t === thumb));
      return;
    }
    if (ev.target.closest('[data-bag-open]')) {
      ev.preventDefault();
      status('');
      window.EDEN.openDialog(drawer);
      return;
    }
    const line = ev.target.closest('[data-line]');
    if (line) { run(() => change(line.dataset.line, Math.max(0, Number(line.dataset.set)))); return; }
    const more = ev.target.closest('[data-pd-more]');
    if (more) {
      const open = $('[data-pd-desc]', pdp).classList.toggle('is-open');
      more.textContent = open ? 'Show less' : 'Read more';
      more.setAttribute('aria-expanded', String(open));
      return;
    }
    // --- search: the magnifier drops a search bar out of the header ----------------
    const searchToggle = ev.target.closest('[data-search-toggle]');
    const panel = $('[data-search-panel]');
    if (searchToggle && panel) {
      ev.preventDefault();
      const opening = panel.hidden;
      panel.hidden = !opening;
      searchToggle.setAttribute('aria-expanded', String(opening));
      if (opening) $('[data-search-input]', panel).focus();
      return;
    }
    if (panel && !panel.hidden && (ev.target.closest('[data-search-close]') || !ev.target.closest('[data-search-panel]'))) {
      panel.hidden = true;
      const t = $('[data-search-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }

    // --- Visit page: swap the map placeholder for the real Google map, only when asked ----
    const mapLoad = ev.target.closest('[data-map-load]');
    if (mapLoad) {
      const box = mapLoad.closest('[data-map-facade]');
      const frame = document.createElement('iframe');
      frame.src = box.dataset.src;
      frame.title = box.dataset.title || 'Map';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      frame.allowFullscreen = true;
      box.replaceChildren(frame);
      frame.focus();
      return;
    }

    const railNext = ev.target.closest('[data-rail-next]');
    if (railNext) {
      const rail = railNext.closest('.rail-wrap').querySelector('[data-rail]');
      const step = rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 20 : 220;
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
      rail.scrollBy({ left: atEnd ? -rail.scrollLeft : step * 2, behavior: 'smooth' });
      return;
    }
    const qtyBtn = ev.target.closest('[data-qty]');
    if (qtyBtn && pdp) {
      const input = $('[data-pd-qty]', pdp);
      input.value = Math.max(1, Math.min(99, (Number(input.value) || 1) + Number(qtyBtn.dataset.qty)));
    }
  });

  // --- gatherings calendar -----------------------------------------------------------------
  // Steps through months. Without this the server-rendered list below it still shows everything.
  for (const root of $$('[data-calendar]')) {
    let events = [];
    try { events = JSON.parse($('[data-cal-events]', root).textContent) || []; } catch (err) { events = []; }
    events = events.filter((e) => /^\d{4}-\d{2}-\d{2}$/.test(e.date || ''));
    if (!events.length) continue;

    const grid = $('[data-cal-grid]', root);
    const head = $('[data-cal-head]', root);
    const label = $('[data-cal-month]', root);
    const empty = $('[data-cal-empty]', root);
    const items = $$('[data-cal-list] li', root);
    const today = new Date();
    const todayKey = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    // Open on the next gathering, or on the most recent one if they have all passed.
    const sorted = [...events].sort((a, b) => a.date.localeCompare(b.date));
    const next = sorted.find((e) => e.date >= todayKey) || sorted[sorted.length - 1];
    let [year, month] = next.date.split('-').map(Number);
    month -= 1;

    function draw() {
      const key = `${year}-${String(month + 1).padStart(2, '0')}`;
      label.textContent = new Date(year, month, 1).toLocaleString('en-US', { month: 'long', year: 'numeric' });
      const first = new Date(year, month, 1).getDay();
      const days = new Date(year, month + 1, 0).getDate();
      const cells = [];
      for (const day of ['S', 'M', 'T', 'W', 'T', 'F', 'S']) cells.push(`<div class="cal-dow" aria-hidden="true">${day}</div>`);
      for (let i = 0; i < first; i++) cells.push('<div class="cal-day is-blank"></div>');
      for (let d = 1; d <= days; d++) {
        const date = `${key}-${String(d).padStart(2, '0')}`;
        const mine = events.filter((e) => e.date === date);
        const marks = mine.map((e) => {
          const text = esc(e.title) + (e.time ? ` <span class="cal-time">${esc(e.time)}</span>` : '');
          return e.url ? `<a class="cal-event" href="${esc(e.url)}">${text}</a>` : `<span class="cal-event">${text}</span>`;
        }).join('');
        cells.push(`<div class="cal-day${date === todayKey ? ' is-today' : ''}${mine.length ? ' has-event' : ''}"><span class="cal-num">${d}</span>${marks}</div>`);
      }
      grid.innerHTML = cells.join('');
      let inMonth = 0;
      for (const li of items) {
        const on = (li.dataset.date || '').startsWith(key);
        li.hidden = !on;
        if (on) inMonth++;
      }
      empty.hidden = inMonth > 0;
    }

    head.hidden = false;
    grid.hidden = false;
    $('[data-cal-prev]', root).addEventListener('click', () => { month--; if (month < 0) { month = 11; year--; } draw(); });
    $('[data-cal-next]', root).addEventListener('click', () => { month++; if (month > 11) { month = 0; year++; } draw(); });
    draw();
  }

  // Escape closes the search bar too.
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'Escape') return;
    const panel = $('[data-search-panel]');
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    const t = $('[data-search-toggle]');
    if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
  });

  // Coming back with the browser's back button can show an old page from cache: refresh the bag.
  window.addEventListener('pageshow', (ev) => { if (ev.persisted) run(load); });
  syncVariant();
  run(load);
})();
